import React from 'react';

import Modal from '../Modal';
import LoginModalMultiBrands from './LoginModalMultiBrands';

const LoginModal = ({ title, isMultiBrands = false, children, onClose }: LoginModalProps) => {
	const handleKeyDown = React.useCallback(
		(event) => {
			if (onClose && event.key === 'Escape') {
				onClose();
			}
		},
		[onClose]
	);

	React.useEffect(() => {
		window.addEventListener('keydown', handleKeyDown);

		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [handleKeyDown]);

	React.useEffect(() => {
		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = 'auto';
		};
	}, []);

	if (isMultiBrands) {
		return (
			<LoginModalMultiBrands title={title || ''} onClose={onClose}>
				{children}
			</LoginModalMultiBrands>
		);
	}

	return (
		<Modal title={title || ''} onClose={onClose}>
			{children}
		</Modal>
	);
};

export default LoginModal;

export interface LoginModalProps {
	title?: string;
	isMultiBrands?: boolean;
	isUS?: boolean;
	children: React.ReactNode;
	onClose: () => void;
}
